import ErrorDialog from "../Error/ErrorDialog";

const ErrorPage = ({ message, emoji, title }) => (
  <div className="w-screen h-screen flex flex-col items-center justify-center bg-black">
    <ErrorDialog message={message} emoji={emoji} title={title}/>
  </div>
);

export default ErrorPage;
